module.exports = __webpack_public_path__ + "img/talent-card.fef89169.svg";